import { useEffect } from "react";
import { startLenis } from "@/lib/lenis";
import { Nav } from "@/components/pow/Nav";
import { Hero } from "@/components/pow/Hero";
import { Marquee } from "@/components/pow/Marquee";
import { Products } from "@/components/pow/Products";
import { Story } from "@/components/pow/Story";
import { Postage } from "@/components/pow/Postage";
import { Faq } from "@/components/pow/Faq";
import { Footer } from "@/components/pow/Footer";
import { CartDrawer } from "@/components/pow/CartDrawer";
import { Checkout } from "@/components/pow/Checkout";

export default function Home() {
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  return (
    <div className="font-body">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Story />
        <Postage />
        <Faq />
      </main>
      <Footer />
      <CartDrawer />
      <Checkout />
    </div>
  );
}
